<template>
  <div class="main-div">
    <v-container fluid grid-list-md :style="{ maxWidth: '1200px' }">
      <v-toolbar v-if="activemarkets !== null" color="transparent">
        <v-toolbar-title style="width: 100%" class="text-xs-center">
          <v-layout row wrap class="toolbar-layout text-xs-right mb-3">
            <v-flex xs12 sm12>
              <v-btn
                round
                class="btn-add-market"
                @click.stop="openDialogForAddMarket()"
                >Add market</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout>
            <v-dialog
              v-model="addSelectedMarketDialogOpened"
              lazy
              max-width="706px"
            >
              <AddSelectedMarket
                ref="addSelectedMarketPopUp"
                @close-dialog="closeDialogForAddMarket"
                @closeFundModal="addSelectedMarketDialogOpened = false"
              ></AddSelectedMarket>
            </v-dialog>
          </v-layout>
        </v-toolbar-title>
      </v-toolbar>
      <v-tabs
        v-if="activemarkets !== null && Object.keys(activemarkets).length !== 0"
        v-model="activeExchangeTab"
        class="my-0"
        slider-color="transparent"
        height="40"
        color="transparent"
      >
        <v-tab
          v-for="(baseCurrencies, exchange, index) in activemarkets"
          :key="index"
          ripple
          class="exchange-tab"
        >
          <img
            :src="
              '/img/' + exchange + (themeDark ? (activeExchanges[activeExchangeTab] === exchange ? '_logo' : '_logo_dark') : '_logo') + '.svg'
            "
            :alt="exchange"
            width="20"
            height="20"
          />
          {{ exchange }}</v-tab
        >
      </v-tabs>
      <v-card
        v-if="activemarkets !== null && Object.keys(activemarkets).length === 0"
        class="card-bordered"
      >
        <v-card-text class="text-xs-center">
          <h3>No markets selected.</h3>
          <p>
            Markets can be selected from "Available Markets" (below).
          </p>
        </v-card-text>
      </v-card>
      <v-tabs-items v-model="activeExchangeTab" touchless>
        <v-tab-item
          v-for="(baseCurrencies, exchange, index) in activemarkets"
          :key="index"
        >
          <ActiveMarketsBase
            v-model="activeTab[exchange]"
            :markets="baseCurrencies"
            :exchange="exchange"
          ></ActiveMarketsBase>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<style scoped>
.no-border {
  box-shadow: none !important;
  background-color: inherit !important;
  border-color: inherit !important;
}
.btn-add-market {
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  box-shadow: none !important;
  margin-left: 0px !important;
  padding: 10px 32px 12px;
}
.theme--light.application .main-div {
  background-color: #f2f7ff !important;
}
.theme--light .card-bordered {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 15px;
  color: #103a84;
}
.theme--light.v-toolbar {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.theme--light .v-toolbar__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #103a84;
}
>>> .theme--light .v-tabs__item {
  color: #468aff;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
}
>>> .v-tabs__item img {
  margin-right: 8px;
}
>>> .theme--light .exchange-tab {
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  margin-right: 2px;
  border-radius: 10px 10px 0px 0px;
  min-width: 144px;
}
>>> .theme--light .exchange-tab a.v-tabs__item--active {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #0051dd;
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 10px 10px 0px 0px;
}
.theme--dark .card-bordered {
  background: #212121;
  box-shadow: none !important;
  border-radius: 15px;
  color: #e9e9e9;
}
>>> .theme--dark .exchange-tab a.v-tabs__item--active {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #ffffff;
  background: #212121;
  border-radius: 10px 10px 0px 0px;
}
.theme--dark.v-toolbar {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.theme--dark .v-toolbar__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #e9e9e9;
}
>>> .theme--dark .v-tabs__item {
  color: #e9e9e9;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
}
>>> .theme--dark.v-tabs__bar {
  background-color: #303030 !important;
}
>>> .theme--dark .exchange-tab {
  background: #454547;
  box-shadow: 6px 4px 10px rgba(0, 0, 0, 0.25);
  margin-right: 2px;
  border-radius: 10px 10px 0px 0px;
  min-width: 144px;
}
>>> .theme--dark
  .v-text-field
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot {
  background: #303030;
  box-shadow: inset 1px 1px 3px rgba(28, 28, 28, 0.34);
  border-radius: 5px;
  padding-left: 5px;
  padding-right: 5px;
}
@media (max-width: 428px) {
  .exchange-tab {
    min-width: 0 !important;
  }
  .container {
    padding: 14px;
  }
}
</style>
<script>
import ActiveMarketsBase from "~/components/markets/ActiveMarketsBase";
import { mapGetters } from "vuex";
import AddSelectedMarket from "../components/markets/AddSelectedMarket";

export default {
  components: {
    ActiveMarketsBase,
    AddSelectedMarket
  },
  data: function() {
    return {
      activeExchangeTab: 0,
      activeAvailableExchangeTab: 0,
      activeTab: {
        Binance: 0,
        Bittrex: 0,
        Huobi: 0
      },
      activeAvailableTab: {
        Binance: 0,
        Bittrex: 0,
        Huobi: 0
      },
      addSelectedMarketDialogOpened: false
    };
  },
  metaInfo() {
    return { title: this.$t("markets") };
  },
  computed: {
    ...mapGetters({
      activemarkets: "markets/activeMarkets",
      themeDark: "settings/darkmode"
    }),
    activeExchanges() {
      if (this.activemarkets) {
        return Object.keys(this.activemarkets);
      }
      return [];
    }
  },
  created: function() {
    if (!this.$store.getters["markets/markets"]) {
      this.$store.dispatch("markets/fetchMarkets");
    }
    if (!this.$store.getters["markets/marketsAll"]) {
      this.$store.dispatch("markets/fetchMarketsAll");
    }
  },
  methods: {
    closeDialogForAddMarket() {
      this.addSelectedMarketDialogOpened = false;
    },
    openDialogForAddMarket() {
      this.addSelectedMarketDialogOpened = true;
      if (this.$refs.addSelectedMarketPopUp) {
        this.$refs.addSelectedMarketPopUp.focus();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/markets.vue